module.exports = __webpack_public_path__ + "static/media/galerija_2021 (6).ecbc0836.jpg";